/* Page to fetch all the Latest Posts
 * Latest is a department choice in the Depts-Xtra app
   So all requests are to department */
import React, { useEffect, useState } from "react"
import Form from "react-bootstrap/Form"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import Container from "react-bootstrap/Container"

import appStyles from "../../App.module.css"
import styles from "../../styles/PostsPage.module.css"
import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import NoResults from "../../assets/no-results.png"
import btnStyles from "../../styles/Button.module.css"
import { useHistory } from "react-router-dom"

import Asset from "../../components/Asset"
import InfiniteScroll from "react-infinite-scroll-component"
import { fetchMoreData } from "../../utils/utils"
import { useRedirect } from "../../hooks/Redirect"
import { Button } from "react-bootstrap"
import TopBox from "../../components/TopBox"
import LatestTop from "./LatestTop"
import LatestCreate from "./LatestCreate"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import useHostName from "../../hooks/useHostName"
import { useCurrentUser } from "../../contexts/CurrentUserContext"
import InfoLatest from "./InfoLatest"

function LatestsPage() {
  const host = useHostName()
  const currentUser = useCurrentUser()
  useRedirect()
  const [show, setShow] = useState(false)
  const [showInfo, setShowInfo] = useState(false);
  const [posts, setPosts] = useState({ results: [] })
  // eslint-disable-next-line
  const [error, setErrors] = useState({})
  const [hasLoaded, setHasLoaded] = useState(false)
  const history = useHistory()

  const [query, setQuery] = useState("")

  const fetchPosts = async () => {
      try {
        if (host === CLIENT_PROGRAM_HOSTNAME) {
          const { data } = await axiosReq.get(
            `department/posts/?departments=latest&search=${query}`
          )
          setPosts(data)
          setHasLoaded(true)
        } else {
          const { data } = await axiosInstance.get(
            `${localStorage.getItem(
              "projectSlug"
            )}/department/posts/?departments=latest&search=${query}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
              withCredentials: true,
            }
          )
          setPosts(data)
          setHasLoaded(true)
        }
      } catch (err) {
        console.log(err)
        if (err.response?.status !== 401) {
          setErrors(err.response?.data)
          setHasLoaded(true)
        }
      }
    }

  useEffect(() => {
    /* Page to fetch all the Latest Posts
     * Latest is a department choice in the Depts-Xtra app
       So all requests are to department */
    setHasLoaded(false)
    const timer = setTimeout(() => {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        fetchPosts()
      } else {
        if (localStorage.getItem("accessToken")) {
          fetchPosts()
        }
      }
    }, 1000)

    return () => {
      clearTimeout(timer)
    }
  }, [query])

  return (
    <div>
      <TopBox work="Latest Buzz" />
      <Row>
        <Col xs={6} >
        <Button
          className={`${btnStyles.Button} ${btnStyles.Blue} mt-1`}
          onClick={() => history.goBack()}
        >
          Back
        </Button>
        </Col>
        <Col xs={6} >
        <Button
        className={`float-right py-0 mt-1 ${btnStyles.Order} ${btnStyles.Button}`}
        onClick={() => setShowInfo((showInfo) => !showInfo)}
      >
        INFO
        </Button>
        </Col>
        </Row>
        {!showInfo ? "" : <InfoLatest />}
      <h5 style={{ textTransform: 'uppercase'}} 
        className={`text-center mb-3 py-1 ${styles.SubTitle }`}>
        LATEST BUZZ</h5>
      <Row>
        <Col className="text-center">
          {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Admin" ||
              currentUser?.groups[0]?.name === "Superadmin" ||
              currentUser?.groups[0]?.name === "Admincreative") && (
              <Button
                onClick={() => setShow((show) => !show)}
                className={`${btnStyles.Button} ${btnStyles.Wide2} ${btnStyles.Bright}`}
              >
                Add Latest Buzz
              </Button>
            )}
          {!show ? "" : <LatestCreate setShow={setShow} />}
        </Col>
      </Row>
      <Row>
        <Col className="py-2 text-center" xs={12} md={{ span: 6, offset: 3 }}>
          <Form
            className={`${styles.SearchBar} mt-3`}
            onSubmit={(event) => event.preventDefault()}
          >
            <Form.Control
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              type="text"
              className={`${styles.InputBar}`}
              placeholder="Search by username or post title"
            />
          </Form>
        </Col>
      </Row>
      <Row className="mt-3 px-2">
        <Col>
          {hasLoaded ? (
            <>
              {posts.results.length ? (
                <InfiniteScroll
                  children={posts.results.map((post) => (
                    <LatestTop key={post.id} {...post}
                    fetchPosts={fetchPosts}
                     setPosts={setPosts} />
                  ))}
                  dataLength={posts.results.length}
                  loader={<Asset spinner />}
                  hasMore={!!posts.next}
                  next={() => fetchMoreData(posts, setPosts)}
                />
              ) : (
                <Container className={appStyles.Content}>
                  <Asset src={NoResults} />
                </Container>
              )}
            </>
          ) : (
            <Container className={appStyles.Content}>
              <Asset spinner />
            </Container>
          )}
        </Col>
      </Row>
    </div>
  )
}

export default LatestsPage
